<template>
    <NuxtLayout>
        <NuxtPage />
        <ClientOnboarding />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {ClientOnboarding, NuxtLayout, NuxtPage} from '#components';
</script>
